import React, { FC, useState } from "react";
import { Box, BoxProps } from "theme-ui";

export const AnimatedMenuButton: FC<BoxProps> = ({ ...props }: BoxProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = (): void => {
    setIsOpen(!isOpen);
  };

  const variant = isOpen
    ? "boxes.header.navbar.menuIconOpen"
    : "boxes.header.navbar.menuIcon";

  return (
    <Box {...props} onClick={toggleMenu} variant={variant}>
      <Box as="span" />
      <Box as="span" />
      <Box as="span" />
    </Box>
  );
};
